import { resolvePublicSearchMeta, type PublicSearchMeta } from '@constants/publicSearch';

function upsertMeta(attribute: 'name' | 'property', key: string, content: string): void {
  const selector = `meta[${attribute}="${key}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attribute, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string): void {
  const existing = document.head.querySelector('link[rel="canonical"]');
  const link = existing instanceof HTMLLinkElement ? existing : document.createElement('link');
  if (!(existing instanceof HTMLLinkElement)) {
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = href;
}

/** Write the title, description, canonical URL, and robots tag for the current page. */
export function applyDocumentMeta(meta: PublicSearchMeta): void {
  document.title = meta.title;
  upsertMeta('name', 'description', meta.description);
  upsertMeta('name', 'robots', meta.robots);
  upsertMeta('property', 'og:title', meta.title);
  upsertMeta('property', 'og:description', meta.description);
  upsertMeta('property', 'og:url', meta.canonicalUrl);
  upsertMeta('name', 'twitter:title', meta.title);
  upsertMeta('name', 'twitter:description', meta.description);
  upsertCanonical(meta.canonicalUrl);
}

export function applyPublicSearchMeta(pathname: string): void {
  applyDocumentMeta(resolvePublicSearchMeta(pathname));
}
